import React from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
function PrincipalMessage() { 
  useEffect(() => {
    document.title = 'Principal Message-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
    const [data, setData] = useState([]);
    useEffect(() => {
     const fetchData = async () => {
       try {
         const msgdata = await getPrincipalMessage();
        const data = msgdata.filter((item) => item.category === "Principal");
        
         setData(data);
       } catch (error) {
         console.error("Error fetching online registration data:", error);
       }  
     };
     fetchData();
   }, []);
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                 
                <li>Principal's Message</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Principal's Message</h2>
            </div> 
          </div> 
          <div className='row'>
          {data.length > 0 && (
              <div className="clearfix">
                 <LazyLoad> <img 
                  src={`https://webapi.entab.info/api/image/${data[0].attachments}`} 
                  className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                  alt={data[0].name || 'Image'}
                /></LazyLoad>
                <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
                <p className="name">
                  {data[0].name}<span> {data[0].category} </span>
                </p>
              </div>
            )}

            {data.length === 0  && (
              <div className="clearfix">
                 <LazyLoad> <img 
                  src="https://webapi.entab.info/api/image/CCSDH/public/Images/topper1.jpg" 
                  className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                  alt=""
                /></LazyLoad>
                
                <p className="name">
                   <span>  Name </span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PrincipalMessage;
